<img src="/assets/images/undraw/trypay/undraw_setup_wizard_r6mr.svg" />

<p>Ta funkcja i wiele innych jest dostępna po zalogowaniu się do <b>Payki</b>.</p>

<mat-dialog-actions align="start">
  <a mat-raised-button href="https://app.payappka.pl/auth/register" color="accent">Załóż konto</a>
  <button mat-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
